<ion-header>

</ion-header>
<ion-content>

    <ion-list>
        <ion-list-header>
            {{ 'COUPON_RECEIVER' | translate }}
        </ion-list-header>
        <ion-item>
            <ion-label class="required alignment-large font-small">{{ 'PRIVATEPROFILE_FIRST_NAME' | translate }}
            </ion-label>
            <ion-input [(ngModel)]="profile.forName" [ngModelOptions]="{standalone: true}" type="text" value="">
            </ion-input>
        </ion-item>

        <ion-item>
            <ion-label class="required alignment-large font-small">{{ 'PRIVATEPROFILE_LAST_NAME' | translate }}
            </ion-label>
            <ion-input [(ngModel)]="profile.surName" [ngModelOptions]="{standalone: true}" type="text" value="">
            </ion-input>
        </ion-item>
    </ion-list>
    <!-- address -->
    <ion-list *ngIf="isAddress">
        <ion-list-header >
          {{ 'PRIVATEPROFILE_STREET_LOCATION_TITLE' | translate }}
        </ion-list-header>
        <ion-item>
          <ion-label class="required alignment-large font-small">{{ 'EVENT_STREET' | translate }}</ion-label>
          <ion-input [(ngModel)]="profile.homeStreet" type="text" ></ion-input>
        </ion-item>
        <ion-item>
          <ion-label class="required alignment-large font-small">{{ 'EVENT_HOUSE' | translate }}</ion-label>
          <ion-input [(ngModel)]="profile.homeStreetNo" type="text"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label class="required alignment-large font-small">{{ 'PRIVATEPROFILE_ZIP' | translate }}</ion-label>
          <ion-input [(ngModel)]="profile.zip" type="number" maxlength="5" pattern="[0-9]*"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label class="required alignment-large font-small">{{ 'PRIVATEPROFILE_CITY' | translate }}</ion-label>
          <ion-input [(ngModel)]="profile.city" type="text"></ion-input>
        </ion-item>
        <ion-item class="search-field-nobg">
          <ion-label class="required alignment-large font-small">{{ 'PRIVATEPROFILE_COUNTRY' | translate }}</ion-label>
          <ion-select [(ngModel)]="profile.country" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
            style="position: static; width: 100%; max-width: inherit;" okText="{{ 'GLOBAL_OK' | translate }}">
            <ion-option *ngFor="let country of countries" value="{{ country.value }}">{{ country.text }}</ion-option>
          </ion-select>
        </ion-item>
      </ion-list>
    <!--  -->
    <ion-list>
        <ion-list-header>
            {{ 'EMAIL_OF_COUPON_RECEIVER' | translate }}
        </ion-list-header>
        <ion-item>
            <ion-label class="required alignment-large font-small">{{ 'EVENT_EMAIL' | translate }}
            </ion-label>
            <ion-input [(ngModel)]="profile.email" [ngModelOptions]="{standalone: true}" type="text" value="">
            </ion-input>
        </ion-item>
    </ion-list>
    <ion-list>
        <ion-item>
            <ion-label class="required alignment-large font-small">{{ 'THE_AMOUNT' | translate }}
            </ion-label>
            <ion-input type="number" [(ngModel)]="profile.quantity" [ngModelOptions]="{standalone: true}">
            </ion-input>
            <div item-content>
                {{ currency }}
            </div>
        </ion-item>
        <ion-item>
            <ion-label class="required alignment-large font-small">{{ 'PAYMENT_QUANTITY' | translate }}
            </ion-label>
            <ion-input type="number" [(ngModel)]="profile.amount" [ngModelOptions]="{standalone: true}">
            </ion-input>
        </ion-item>
    </ion-list>

    <div padding-top padding-bottom radio-group class="background-colored">

        <div class="flex-space-between margin-sides-small padding-vert-small border-top"
            (click)="setPaymentMethod('paypal')">
            <div class="flex-space-between">
                <img class="item-small" src="/assets/imgs/payments/paypal.png" />
                <p class="font-black margin-left-small">{{ 'PAY_WITH_PAYPAL' | translate }}</p>
            </div>
        </div>
        <ion-card class="welcome-card" *ngIf="paymentMethod === 'paypal'">
            <ion-card-content>
                <div flex-space-between>
                    <div style="text-align: center;" [hidden]="paidFor" #paypal></div>
                </div>
            </ion-card-content>
        </ion-card>

        <div (click)="setPaymentMethod('stripe-credit')"
            class="flex-space-between margin-sides-small padding-vert-small border-both">
            <div class="flex-space-between">
                <img class="item-medium" src="/assets/imgs/payments/creditcard.jpg" />
                <p class="font-black margin-left-small">{{ 'PAY_WITH_CREDITCARD' | translate }}</p>
            </div>
        </div>
        <ion-card class="welcome-card" *ngIf="paymentMethod === 'stripe-credit'">
            <ion-card-content>
                <div class="form-row" style="padding-left: 1px;">
                    <div id="card-element">
                    </div>
                    <div id="card-errors" role="alert"></div>
                </div>
                <button margin-top ion-button small color="success" expand="full" (click)="payCreditCard()">{{
                    'PAY_NOW'
                    | translate }}</button>
            </ion-card-content>
        </ion-card>

        <div (click)="payGiropay()" *ngIf="currency === 'eur' || currency === 'EUR'"
            class="flex-space-between margin-sides-small padding-vert-small border-both">
            <div class="flex-space-between">
                <img class="item-giropay" src="/assets/imgs/payments/gyropay.png" />
                <p class="font-black margin-left-small">{{ 'PAY_WITH_GIROPAY' | translate}}</p>
            </div>
        </div>

        <div (click)="paySofort()" *ngIf="currency === 'eur' || currency === 'EUR'"
            class="flex-space-between margin-sides-small padding-vert-small border-both">
            <div class="flex-space-between">
                <img class="item-sofort" src="/assets/imgs/payments/sofort.png" />
                <p class="font-black margin-left-small">{{ 'PAY_WITH_SOFORT' | translate}}</p>
            </div>
        </div>

    </div>
</ion-content>